import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mcb-grid-toolbar',
  template: '<div class="mcb-grid-toolbar">\n' + '  <ng-content></ng-content>\n' + '</div>'
})
export class GridToolbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
